import { render, staticRenderFns } from "./SyaratSlotSOS.vue?vue&type=template&id=c85b50ce&scoped=true"
import script from "./SyaratSlotSOS.vue?vue&type=script&lang=js"
export * from "./SyaratSlotSOS.vue?vue&type=script&lang=js"
import style0 from "./SyaratSlotSOS.vue?vue&type=style&index=0&id=c85b50ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85b50ce",
  null
  
)

export default component.exports